
const Spanish = {
    "form.isRequired": "se requiere {name}",
    "form.OTPLabel": "Código de verificación de correo electrónico",
    "form.OTPInputValidMessage": "Correcto",
    "form.OTPInputInvalidMessage": "OTP incorrecta",
    "form.OTPWaitSecondsLabel": "Enviar nuevamente ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "Enviar OTP",
    "form.OTPSendSuccessLabel": "Envío correcto del código de verificación a su correo electrónico",
    "form.OTPTips": "Ingresar OTP válida",
    "form.selectInputLabel": "Buscar…",
    "form.uploadBtn": "CARGA",
    "form.uploadSizeTips": "Los archivos deben ser de menos de 5 MB.",
    "form.uploadTypeTips": "Tipos de archivos permitidos: png gif jpg jpeg pdf.",
    "form.uploadNumTips": "Se debe cargar un archivo",
    "form.isRequiredAccept": "Aceptar para continuar.",
    "form.sendButton": "ENVIAR",
    "form.isEmail": "Ingresar una cuenta de correo electrónico válida",
    "form.isSerialNumber": "Ingresar 13 caracteres en {name}.",
    "form.categoryPlaceholder": "- Seleccionar categoría de producto -",
    "form.seriesPlaceholder": "- Seleccionar serie de producto -",
    "form.skuPlaceholder": "- Modelo N.º (SKU) -",
    "form.sendSuccessMsg": "Envío correcto",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    Spanish
}   